import React from 'react';
import range from 'lodash/range';

import {theme} from 'charts/components/style';
import {Line, Quadrant} from 'charts/index';
import {BackgroundLabel} from 'charts/components/decorators/BackgroundLabel';

import {margins, scales} from 'components/dashboard/manager/nine-box/NineBox.const';

const ROW_COUNT = 3;
const COL_COUNT = 3;
const ROW_STEP = 100 / ROW_COUNT;
const COL_STEP = 100 / COL_COUNT;

interface NineBoxGridProps {
  blockNames?: string[];
  title?: string[];
}

export const NineBoxGrid: React.FC<NineBoxGridProps> = ({title = [], blockNames = []}) => {
  const isCoachingZone = title.length !== 0;

  return (
    <g>
      {range(ROW_COUNT).map(row =>
        range(COL_COUNT).map(column => {
          const i = row * COL_COUNT + column;
          const isNotLast = row + 1 !== ROW_COUNT && column + 1 !== COL_COUNT;
          const isHighlight = isCoachingZone && isNotLast;
          return (
            <Quadrant
              key={i}
              area={{
                x: COL_STEP * column,
                x2: COL_STEP * (column + 1),
                y: ROW_STEP * row,
                y2: ROW_STEP * (row + 1),
              }}
              scales={scales}
              margins={margins}
              fill={
                isHighlight ? theme.colors.chartBackgroundHighlight : theme.colors.chartBackground
              }
              label={isCoachingZone ? blockNames[i] || '' : ''}
            />
          );
        })
      )}

      {range(ROW_COUNT - 1).map(row => {
        const isLast = !row;
        const isHighlight = isCoachingZone && isLast;
        return (
          <Line
            key={`row-${row}`}
            scales={scales}
            at={ROW_STEP * (row + 1)}
            orientation="horizontal"
            stroke={isHighlight ? theme.colors.chartLinePrimary : theme.colors.chartLineSecondary}
          />
        );
      })}

      {range(COL_COUNT - 1).map(column => {
        const isLast = column + 2 === COL_COUNT;
        const isHighlight = isCoachingZone && isLast;
        return (
          <Line
            key={`column-${column}`}
            scales={scales}
            at={COL_STEP * (column + 1)}
            orientation="vertical"
            stroke={isHighlight ? theme.colors.chartLinePrimary : theme.colors.chartLineSecondary}
          />
        );
      })}

      <BackgroundLabel labels={title} location={{x: 5, y: 100}} scales={scales} />
    </g>
  );
};
